import './index.scss'
import { registerFormatType, toggleFormat, applyFormat } from '@wordpress/rich-text';
import { RichTextToolbarButton } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { useSelect } from '@wordpress/data';
import { useState, useEffect } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import {	
	PanelBody,		
	RangeControl,
	ColorPalette,
	TextControl,
	SelectControl
} from '@wordpress/components';


const formatTypes = [
	{ type: 'aver/text-shadow', title: 'Add Text Shadow', className: 'p-text-shadow' },
	{ type: 'aver/neon', title: 'Add Neon', className: 'neon' },
];

formatTypes.forEach(({ type, title, className }) => {
	registerFormatType(type, {
		title: __(title, 'aver'),
		tagName: 'span',
		className,
		
		edit({ isActive, onChange, value }) {
			const selectedBlock = useSelect((select) =>
				select('core/block-editor').getSelectedBlock()
			);

			return (
				<>
					{(selectedBlock?.name === 'core/paragraph' || selectedBlock?.name === 'core/heading') && (
						<RichTextToolbarButton
							title={__(title, 'aver')}
							icon="editor-textcolor"					
							isActive={isActive}
							onClick={() => {
								onChange(
									toggleFormat(value, { type })
								);
							}}
						/>
					)}
				</>
			);
		},
	});
});



registerFormatType( 'aver/headinglinesformat', {
	title: __( 'Title Lines', 'aver' ),
	tagName: 'span',
	className: 'headinglines', 
	edit: ( { isActive,  onChange, value } ) => {

		const selectedBlock = useSelect( ( select ) =>
			select( 'core/block-editor' ).getSelectedBlock()
		);

		const formatAttributes = value.activeFormats?.[0]?.attributes || {};
		const [ gap, setGap ] = useState( formatAttributes.gap || 20 );
		
	
		return (
			<>
				{ ( selectedBlock?.name === 'core/paragraph' || selectedBlock?.name === 'core/heading' )  && ( 
					<>				
						<RichTextToolbarButton
							title={ __( 'Add Title Lines', 'aver' ) }
							icon="editor-textcolor"
							isActive={ isActive }
							onClick={ () => {					
								onChange(
									toggleFormat( value, {
										type: 'aver/headinglinesformat',
										attributes: {																												
											style: `grid-template-rows: ${gap}px 0`,																						
										},
									} )
								);
							} }					
						/>
	
						{	isActive && 	
							<InspectorControls>
								<PanelBody title={ __( 'Heading Lines', 'aver' ) } initialOpen={ false }>						
									<RangeControl
										label={ __( 'Grid Template Rows(px)', 'aver' ) }
										value={ gap	}
										min={ 0 }
										max={ 100 }
										step={ 1 }
										onChange={ ( newval )=> { 
											setGap( newval )					  											
											onChange(	
												applyFormat(value, {
													type: 'aver/headinglinesformat',
													attributes: {		
														style: `grid-template-rows: ${newval}px 0`,	
													}
												})
											)            
										}}
									/>					
								</PanelBody>
							</InspectorControls>
						}					
					</>
				) } 
			</>
		);
	}
	
} );



registerFormatType( 'aver/shadowformat', {
	title: __( 'Text Outline', 'aver' ),
	tagName: 'span',
	className: 'someformat',
	edit: ( { isActive, onChange, value } ) => {

			const selectedBlock = useSelect( ( select ) =>
					select( 'core/block-editor' ).getSelectedBlock()
			);

			const formatAttributes = value.activeFormats?.[0]?.attributes || {};
			const [outsidecolor, setColor] = useState(formatAttributes.outsidecolor || '#528D8E');
			const [insideColor, setBgColor] = useState(formatAttributes.insideColor || '#fff');

			// Get theme.json colors correctly
			const colors = useSelect((select) => select('core/editor').getEditorSettings().colors);

			return (
					<>
							{( selectedBlock?.name === 'core/paragraph' || selectedBlock?.name === 'core/heading' ) && ( 
									<>
											<RichTextToolbarButton
													title={ __( 'Add Text Outline', 'aver' ) }
													icon="editor-textcolor"
													isActive={ isActive }
													onClick={ () => {                    
															onChange(
																	toggleFormat( value, {
																			type: 'aver/shadowformat',
																			attributes: {  
																				style: `text-shadow: -.0625rem 0 ${outsidecolor}, 0 .0625rem ${outsidecolor}, .0625rem 0 ${outsidecolor}, 0 -.0625rem ${outsidecolor}; color: ${insideColor}`,                                
																			},
																	})
															);
													}}                    
											/>

											{isActive && (
													<InspectorControls>
															<PanelBody title={ __( 'Text Outline', 'aver' ) } initialOpen={ true }>   

																	<p>{__('Outline Color:', 'aver')}</p>
																	<ColorPalette 
																			label={ __( 'Outline Color', 'aver' ) }
																			disableCustomColors={ false }
																			clearable={ true }
																			colors={ colors }
																			enableAlpha={ true }
																			value={ outsidecolor }
																			onChange={ ( newval ) => { 
																					setColor(newval);    
																					onChange(
																							applyFormat(value, {
																									type: 'aver/shadowformat',
																									attributes: {  
																										style: `text-shadow: -.0625rem 0 ${newval}, 0 .0625rem ${newval}, .0625rem 0 ${newval}, 0 -.0625rem ${newval}; color: ${insideColor}`,        
																									}
																							})
																					);                                            
																			}}
																	/>             
																	<p>{__('Text Color:', 'aver')}</p>
																	<ColorPalette 
																			label={ __( 'Text Color', 'aver' ) }
																			disableCustomColors={ false }
																			clearable={ true }
																			colors={ colors }
																			enableAlpha={ true }
																			value={ insideColor }
																			onChange={ ( newval ) => {    
																					setBgColor(newval);    
																					onChange(
																							applyFormat(value, {
																									type: 'aver/shadowformat',
																									attributes: {
																										style: `text-shadow: -.0625rem 0 ${outsidecolor}, 0 .0625rem ${outsidecolor}, .0625rem 0 ${outsidecolor}, 0 -.0625rem ${outsidecolor}; color: ${newval}`,                                            
																									}
																							})
																					);                                                    
																			}}
																	/>
																
															</PanelBody>
													</InspectorControls>
											)}
									</>
							)}
					</>
			);
	}
});


registerFormatType( 'aver/tag-format', {
  title: __( 'Add Tag Format', 'aver' ),
  tagName: 'span',
  className: 'p-tag-format',
  edit: ( { isActive, onChange, value } ) => {

      const selectedBlock = useSelect( ( select ) =>
          select( 'core/block-editor' ).getSelectedBlock()
      );

      const formatAttributes = value.activeFormats?.[0]?.attributes || {};
      const [bgColor, setBgColor] = useState(formatAttributes.bgColor || '#528D8E');
      const [color, setColor] = useState(formatAttributes.color || '#fff');
			

      // grab theme.json colors correctly
      const colors = useSelect((select) => select('core/editor').getEditorSettings().colors);

      return (
          <>
              {( selectedBlock?.name === 'core/paragraph' || selectedBlock?.name === 'core/heading' ) && ( 
                  <>
                      <RichTextToolbarButton
                          title={ __( 'Add Tag Format', 'aver' ) }
                          icon="editor-textcolor"
                          isActive={ isActive }
                          onClick={ () => {                    
                              onChange(
                                  toggleFormat( value, {
                                      type: 'aver/tag-format',
                                      attributes: {  
                                          style: `background-color:${bgColor}; color:${color};`,                                
                                      },
                                  })
                              );
                          }}                    
                      />

                      {isActive && (
                          <InspectorControls>
                              <PanelBody title={ __( 'Add Tag Format', 'aver' ) } initialOpen={ true }>   

                                  <p>{__('Background Color:', 'aver')}</p>
                                  <ColorPalette 
                                      label={ __( 'Background Color', 'aver' ) }
                                      disableCustomColors={ false }
                                      clearable={ true }
                                      colors={ colors }
                                      enableAlpha={ true }
                                      value={ bgColor }
                                      onChange={ ( newval ) => { 
                                          setBgColor(newval);    
                                          onChange(
                                              applyFormat(value, {
                                                  type: 'aver/tag-format',
                                                  attributes: {  
                                                      style: `background-color:${newval}; color:${color} `,        
                                                  }
                                              })
                                          );                                            
                                      }}
                                  />             
                                  <p>{__('Text Color:', 'aver')}</p>
                                  <ColorPalette 
                                      label={ __( 'Text Color', 'aver' ) }
                                      disableCustomColors={ false }
                                      clearable={ true }
                                      colors={ colors }
                                      enableAlpha={ true }
                                      value={ color }
                                      onChange={ ( newval ) => {    
                                          setColor(newval);    
                                          onChange(
                                              applyFormat(value, {
                                                  type: 'aver/tag-format',
                                                  attributes: {                                                          
                                                      style: `background-color:${bgColor}; color:${newval} `,    
                                                  }
                                              })
                                          );                                                    
                                      }}
                                  />
                                
                              </PanelBody>
                          </InspectorControls>
                      )}
                  </>
              )}
          </>
      );
  }
});


const formatTypespp = [
	{ type: 'aver/underlinetitleformat', title: 'Add Hover Underline', className: 'hover-underline-animation' },
];

formatTypespp.forEach(({ type, title, className }) => {

	registerFormatType(type, {
		title: __(title, 'aver'),
		tagName: 'span',
		className,

		edit: ({ isActive, onChange, value }) => {
			const formatAttributes = value.activeFormats?.[0]?.attributes || {};

			const [bgColor, setBgColor] = useState(formatAttributes.bgColor || '#333');
			const [bottom, setBottom] = useState(formatAttributes.bottom || -5);
			const [borderwidth, setBorderwidth] = useState(formatAttributes.borderwidth || 2);
			const [currentClass, setCurrentClass] = useState(formatAttributes.class || 'underlinehover');

			const colors = useSelect('core/block-editor').getSettings().colors;

			const selectedBlock = useSelect((select) =>
				select('core/block-editor').getSelectedBlock()
			);

			return (
				<>
					{(selectedBlock?.name === 'core/paragraph' || selectedBlock?.name === 'core/heading') && (
						<>
							<RichTextToolbarButton
								title={__(title, 'aver')}
								icon="editor-textcolor"
								isActive={isActive}
								onClick={() => {
									onChange(
										toggleFormat(value, {
											type,
											attributes: {
												//class: currentClass,
												style: `--hover-underline-color: ${bgColor}; --bottom-gap:${bottom}; --borderwidth:${borderwidth}`,
											},
										})
									);
								}}
							/>

							{isActive && (
								<InspectorControls>
									<PanelBody title={__('Underline Settings', 'aver')} initialOpen={true}>

										<SelectControl
											label={__('Animation Style', 'aver')}
											value={currentClass}
											options={[											
												{ label: 'Underline Hover', value: 'underlinehover' },
												{ label: '(Pro Version & Group Animaiton On)Underline Animation when scroll', value: 'ani' },
											]}
											onChange={(newClass) => {
												setCurrentClass(newClass);
												onChange(
													applyFormat(value, {
														type,
														attributes: {
															class: newClass,
															style: `--hover-underline-color: ${bgColor}; --bottom-gap:${bottom}; --borderwidth:${borderwidth}`,
														},
													})
												);
											}}
										/>

										<ColorPalette
											label={__('Color', 'aver')}
											disableCustomColors={false}
											clearable={true}
											colors={colors}
											enableAlpha={true}
											value={bgColor}
											onChange={(newval) => {
												setBgColor(newval);
												onChange(
													applyFormat(value, {
														type,
														attributes: {
															class: currentClass,
															style: `--hover-underline-color: ${newval}; --bottom-gap:${bottom}; --borderwidth:${borderwidth}`,
														},
													})
												);
											}}
										/>

										<TextControl
											label={__('Bottom Gap (px) e.g. -5', 'aver')}
											type="number"
											value={bottom}
											onChange={(newval) => {
												setBottom(newval);
												onChange(
													applyFormat(value, {
														type,
														attributes: {
															class: currentClass,
															style: `--hover-underline-color: ${bgColor}; --bottom-gap:${newval}; --borderwidth:${borderwidth}`,
														},
													})
												);
											}}
											__nextHasNoMarginBottom={true}
										/>

										<TextControl
											label={__('Border Width (px) e.g. 2', 'aver')}
											type="number"
											value={borderwidth}
											onChange={(newval) => {
												setBorderwidth(newval);
												onChange(
													applyFormat(value, {
														type,
														attributes: {
															class: currentClass,
															style: `--hover-underline-color: ${bgColor}; --bottom-gap:${bottom}; --borderwidth:${newval}`,
														},
													})
												);
											}}
											__nextHasNoMarginBottom={true}
										/>

									</PanelBody>
								</InspectorControls>
							)}
						</>
					)}
				</>
			);
		}
	});
});
